import React, {memo, useCallback, useMemo} from "react"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SubMenuComponent} from "../../../../components/SubMenu"
import {useLocalization} from "../../../../hooks/localization"
import iconLogs from "../../../../assets/images/icons/settings/log.png"
import iconSettingsUpdate from '../../../../assets/images/icons/settings/settingsupdate.png'
import {useSelector} from "react-redux"
import {UserRole} from "../../../../types/control"
import {hasAuthority} from "../../../../utils/role"

type SubMenuType = {
    icon: string
    name: string
    path: string
    role: UserRole
}
export const AdvancedMenu = memo(function AdvancedMenu() {
    const {t} = useLocalization()
    const role = useSelector(state => state.ui.role)
    const allowedRole = useCallback((select: UserRole) => hasAuthority(role, select), [role])
    const customMenuRoutes = useMemo<SubMenuType[]>(
        () => [
            {
                icon: iconLogs,
                name: t("supervisor_config"),
                path: "/settings/advanced-settings/supervisor-config",
                role: "developer"
            },
            {
                icon: iconLogs,
                name: t("worker_config"),
                path: "/settings/advanced-settings/worker-config",
                role: "developer"
            },
            {
                icon: iconLogs,
                name: t("test"),
                path: "/settings/advanced-settings/test",
                role: "developer"
            },
            {
                icon: iconLogs,
                name: t("panel_settings"),
                path: "/settings/advanced-settings/panel-settings",
                role: "service"
            },
            {
                icon: iconLogs,
                name: t("developer_menu"),
                path: "/developer",
                role: "developer"
            },
            {
                icon: iconLogs,
                name: t("auto_desktop"),
                path: "/settings/advanced-settings/auto-desktop",
                role: "service"
            },
            {
                icon: iconSettingsUpdate,
                name: t("update_lowercase"),
                path: "/settings/advanced-settings/update",
                role: "developer"
            }
        ],
        [t]
    )
    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer buttons={[]} className="service-edit" backUrl={"/settings"} style={null}>
                <div className="content-divider">
                    <div className="sub-menu-content-divider">
                    {customMenuRoutes.map(
                        (control, index) =>
                            allowedRole(control?.role) && (
                                <SubMenuComponent
                                    key={index}
                                    icon={control.icon}
                                    name={control.name}
                                    path={control.path}
                                />
                            )
                    )}
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
